// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"631":"a14e1406","787":"cb9d7cb2"}[chunkId] + ".chunk.js";
};